<template>
    <footer class="main-container">
        <nav class="image-wrapper">
            <svg data-v-423bf9ae="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290.60372844405344 60" class="font">
                <g data-v-423bf9ae="" id="4123ace1-15a9-4d73-bd23-6024d593b910" fill="var(--primary-color)"
                    transform="matrix(5.567424670000685,0,0,5.567424670000685,-3.095871091831185,0.24315172901449245)">
                    <path
                        d="M3.70 4.54L3.70 4.54C3.56 4.82 3.74 5.17 4.05 5.21C5.36 5.38 6.19 6.09 6.19 7.46C6.19 11.05-0.14 10.65 1.90 5.49C2.56 3.85 3.28 2.21 3.95 0.59C4.17 0.03 3.33-0.32 3.09 0.24C2.41 1.88 1.69 3.51 1.04 5.17C-1.55 11.72 7.10 12.49 7.10 7.46C7.10 5.88 6.23 4.80 4.76 4.40L6.38 0.66C6.64 0.10 5.80-0.28 5.54 0.29ZM3.67 6.97L3.67 6.97C4.34 6.97 4.34 7.95 3.67 7.95C3.42 7.95 3.21 8.16 3.21 8.41C3.21 9.06 4.16 8.97 4.68 8.47C5.57 7.60 4.98 6.05 3.67 6.05C3.07 6.05 3.07 6.97 3.67 6.97ZM14.04 0.71L14.04 0.71C13.06 0.38 12.38 0.27 11.54 0.31C8.65 0.45 7.42 3.99 9.45 5.77C10.75 6.90 12.14 6.79 12.19 7.45C12.28 8.15 10.39 8.01 9.31 7.22C8.82 6.87 8.27 7.63 8.76 7.98C9.69 8.65 10.82 8.88 11.73 8.82C12.49 8.76 13.17 8.19 13.13 7.41C13.03 5.92 11.30 6.16 10.08 5.07C9.07 4.20 9.27 2.73 10.02 1.93C10.95 0.91 12.46 1.15 13.72 1.60C14.31 1.81 14.62 0.91 14.04 0.71ZM8.58 9.97L8.58 9.97C9.13 10.26 9.67 10.44 10.15 10.54C12.77 11.17 15.04 9.97 15.04 7.41C15.04 4.80 11.97 4.24 11.45 3.85C10.99 3.49 11.35 2.62 13.47 3.47C14.04 3.71 14.38 2.84 13.83 2.62C10.35 1.20 9.76 3.68 10.88 4.56C11.59 5.14 14.11 5.49 14.11 7.41C14.11 10.00 11.19 10.29 9.03 9.14C8.48 8.86 8.05 9.69 8.58 9.97ZM11.65 7.90L11.65 7.90L11.65 7.90L11.65 7.90ZM22.89 2.23L22.89 2.23L20.54 2.23C20.29 2.23 20.08 2.44 20.08 2.70L20.08 10.16C20.08 10.43 20.29 10.64 20.54 10.64C20.80 10.64 21.01 10.43 21.01 10.16L21.01 3.15L22.89 3.15C23.14 3.15 23.34 2.95 23.34 2.70C23.34 2.44 23.14 2.23 22.89 2.23ZM16.35 1.29L16.35 1.29L22.89 1.29C23.14 1.29 23.34 1.08 23.34 0.83C23.34 0.56 23.14 0.36 22.89 0.36L16.35 0.36C16.09 0.36 15.88 0.56 15.88 0.83C15.88 1.08 16.09 1.29 16.35 1.29ZM16.35 3.15L16.35 3.15L18.20 3.15L18.20 10.16C18.20 10.43 18.42 10.64 18.68 10.64C18.94 10.64 19.15 10.43 19.15 10.16L19.15 2.70C19.15 2.44 18.94 2.23 18.68 2.23L16.35 2.23C16.09 2.23 15.88 2.44 15.88 2.70C15.88 2.95 16.09 3.15 16.35 3.15ZM26.67 7.84L26.67 7.84L28.03 7.84C28.29 7.84 28.52 7.63 28.52 7.36C28.52 7.29 28.50 7.24 28.48 7.18L27.79 5.50C27.69 5.28 27.43 5.17 27.17 5.26C26.95 5.35 26.84 5.63 26.92 5.87L27.34 6.90L26.67 6.90C26.42 6.90 26.21 7.10 26.21 7.36C26.21 7.63 26.42 7.84 26.67 7.84ZM25.98 10.26L25.98 10.26L26.22 9.72L28.49 9.72L28.71 10.26C28.81 10.51 29.09 10.61 29.33 10.53C29.57 10.42 29.67 10.15 29.58 9.91L29.25 9.10C29.19 8.92 29.01 8.76 28.80 8.76L25.90 8.76L25.90 8.76C25.73 8.76 25.55 8.89 25.47 9.06L25.13 9.91C25.03 10.15 25.14 10.42 25.38 10.53C25.63 10.61 25.90 10.50 25.98 10.26ZM23.98 10.26L23.98 10.26L27.36 1.76L30.73 10.26C30.83 10.50 31.11 10.61 31.35 10.53C31.58 10.42 31.70 10.15 31.60 9.91L27.79 0.36C27.75 0.25 27.66 0.14 27.52 0.10C27.30 0 27.02 0.11 26.92 0.36L23.10 9.91C23.02 10.15 23.14 10.42 23.37 10.53C23.60 10.61 23.87 10.50 23.98 10.26ZM38.56 2.23L38.56 2.23L36.20 2.23C35.95 2.23 35.74 2.44 35.74 2.70L35.74 10.16C35.74 10.43 35.95 10.64 36.20 10.64C36.47 10.64 36.68 10.43 36.68 10.16L36.68 3.15L38.56 3.15C38.81 3.15 39.00 2.95 39.00 2.70C39.00 2.44 38.81 2.23 38.56 2.23ZM32.02 1.29L32.02 1.29L38.56 1.29C38.81 1.29 39.00 1.08 39.00 0.83C39.00 0.56 38.81 0.36 38.56 0.36L32.02 0.36C31.75 0.36 31.54 0.56 31.54 0.83C31.54 1.08 31.75 1.29 32.02 1.29ZM32.02 3.15L32.02 3.15L33.87 3.15L33.87 10.16C33.87 10.43 34.09 10.64 34.34 10.64C34.61 10.64 34.82 10.43 34.82 10.16L34.82 2.70C34.82 2.44 34.61 2.23 34.34 2.23L32.02 2.23C31.75 2.23 31.54 2.44 31.54 2.70C31.54 2.95 31.75 3.15 32.02 3.15ZM43.33 10.18L43.33 10.18L43.33 0.81C43.33 0.56 43.12 0.35 42.87 0.35C42.60 0.35 42.39 0.56 42.39 0.81L42.39 10.18C42.39 10.43 42.60 10.64 42.87 10.64C43.12 10.64 43.33 10.43 43.33 10.18ZM41.45 10.18L41.45 10.18L41.45 0.81C41.45 0.56 41.24 0.35 40.99 0.35C40.73 0.35 40.52 0.56 40.52 0.81L40.52 10.18C40.52 10.43 40.73 10.64 40.99 10.64C41.24 10.64 41.45 10.43 41.45 10.18ZM52.47 0.56L52.47 0.56C51.81 0.29 51.11 0.15 50.40 0.15C46.87 0.15 45.12 2.81 45.14 5.47C45.15 8.09 46.91 10.71 50.40 10.71C51.11 10.71 51.81 10.57 52.47 10.30C53.03 10.08 52.68 9.21 52.11 9.45C51.56 9.66 51.00 9.79 50.40 9.79C47.53 9.79 46.06 7.64 46.05 5.45C46.05 2.98 47.84 1.08 50.36 1.08C50.96 1.08 51.55 1.19 52.11 1.43C52.68 1.65 53.03 0.80 52.47 0.56ZM51.83 7.50L51.83 7.50C51.35 7.77 50.83 7.88 50.34 7.87C49.14 7.83 48.06 6.99 48.06 5.45C48.06 3.26 50.20 2.46 51.83 3.36C52.36 3.67 52.81 2.84 52.26 2.56C49.99 1.29 47.14 2.56 47.14 5.45C47.14 7.52 48.65 8.78 50.36 8.81C51.00 8.82 51.66 8.67 52.26 8.32C52.81 8.02 52.36 7.22 51.83 7.50Z">
                    </path>
                </g>
            </svg>
            <div class="navigation">
                <a href="/shop" class="link">Art Shop</a>
                <a href="/bot-services" class="link">Bot Services</a>
                <a href="/aboutus" class="link">About Us</a>
                <a href="/contact" class="link">Contact</a>
                <a href="/faq" class="link">FAQ</a>
            </div>
        </nav>
        <div class="divider"></div>
        <div class="footer-content">
            <div class="footer-section">
                <p class="footer-text">© 2023 - {{ new Date().getFullYear() }} 6static. All rights reserved.</p>
                <div class="footer-links">
                    <a target="_blank" href="/privacy" class="link">Privacy Policy</a>
                    <a target="_blank" href="/terms" class="link">Terms and Conditions</a>
                    <a target="_blank" href="/impress" class="link">Impress</a>
                    <a target="_blank" href="/cookies" class="link">Cookie Policy</a>
                </div>
            </div>
        </div>
    </footer>
</template>
  
<style scoped>
.main-container {
    align-items: center;
    display: flex;
    flex-direction: column;
}

.image-wrapper {
    align-items: center;
    align-self: center;
    display: flex;
    width: 434px;
    max-width: 100%;
    flex-direction: column;
}

@media (max-width: 991px) {
    .image-wrapper {
        margin-top: 2.5;
    }
}

.img {
    aspect-ratio: 2.33;
    object-fit: cover;
    object-position: center;
    /* width: 63px; */
    overflow: hidden;
    align-self: center;
    max-width: 100%;
}

.navigation {
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    margin-top: 2rem;
    width: 100%;
    justify-content: space-between;
    gap: 20px;
}

@media (max-width: 991px) {
    .navigation {
        max-width: 100%;
        flex-wrap: wrap;
        justify-content: center;
    }
}

.link {
    color: var(--primary-color);
    align-self: stretch;
    font: 600 1rem/150% var(--secondary-font-family, Roboto), sans-serif;
}

.footer-content {
    align-items: center;
    align-self: center;
    display: flex;
    width: 100%;
    max-width: 1312px;
    flex-direction: column;
}

@media (max-width: 991px) {
    .footer-content {
        max-width: 100%;
        margin: 40px 0;
    }
}

.divider {
    align-self: stretch;
    background-color: var(--primary-color);
    display: flex;
    width: 100%;
    height: 1px;
    flex-direction: column;
    gap: 5rem;
}

@media (max-width: 991px) {
    .divider {
        max-width: 100%;
    }
}

.footer-section {
    justify-content: space-between;
    align-items: flex-start;
    align-self: center;
    display: flex;
    width: 100%;
    gap: 1.5rem;
}

@media (max-width: 991px) {
    .footer-section {
        max-width: 100%;
        flex-wrap: wrap;
    }
}

.footer-text {
    color: var(--primary-color, var(--Black, #000));
    font: 400 0.875rem/150% var(--secondary-font-family, Roboto), sans-serif;
}

.footer-links {
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    max-width: 100%;
    justify-content: space-between;
    gap: 1.5rem;
}

@media (max-width: 991px) {
    .footer-links {
        justify-content: center;
    }
}
</style>